import { blogPosts } from 'common/data/AppCreative';
import { useRouter } from "compat/router";
import { Text } from "@mantine/core";
import React, { Fragment, useEffect } from 'react';
import Head from 'compat/Head';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/theme/appCreative';
import ResetCSS from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/AppCreative/Navbar';
import BlogPostBanner from 'containers/AppCreative/BlogPostBanner';
import BlogPostContent from 'containers/AppCreative/BlogPostContent';
import Footer from 'containers/AppCreative/Footer';
import GlobalStyle, { AppWrapper, ContentWrapper } from 'containers/AppCreative/appCreative.style';
import bannerImg from 'common/assets/image/appCreative/bannerImg_linok_team.png';
import bannerImgMobile from 'common/assets/image/appCreative/bannerImg_linok_team_mobile.png';
import { IconShare } from "@tabler/icons-react";
import Link from "compat/Link";


export default function BlogPost() {
  const router = useRouter();
  const id = router.query.id?.toString();
  const post = blogPosts.find((post) => post.id === id);

  if (!post) return <Text align="center" size="lg">Post not found</Text>;

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Head>
          <title>{`Linok Blog | ${post.title}`}</title>
          <link rel="icon" href="/favicon.png" />
          <meta name="description" content={post.content.length > 0 ? post.content[0].content : "Revolutionizing dairy management with cutting-edge technology, Linok provides real-time data analytics and insights to help farmers make smarter decisions, optimize herd health, boost production efficiency, and achieve sustainable growth"} />
          <meta name="theme-color" content="#156b83" />
          <meta name="keywords" content="Linok, dairy, farming, data, sensors" />
        </Head>
        {/* end of head */}
        <ResetCSS />
        <GlobalStyle />
        {/* end of global and reset style */}
        {/* start app creative landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar />
          </Sticky>
          <ContentWrapper>
            <BlogPostBanner
              title={post ? post.title : 'Linok Blog Post'}
              subtitle={`Meet the professional and innovative minds driving Linok’s vision—dedicated to transforming the future of dairy`}
              bannerImg={bannerImg}
              bannerImgMobile={bannerImgMobile}
            />
            {post && <BlogPostContent post={post} />}
          </ContentWrapper>
          <Footer />
        </AppWrapper>
      </Fragment>
    </ThemeProvider>
  );
}
